export class SpecialServices {
    Service: Service;  
}

export class Service {
    ServiceType: any;  
}